import { Fragment } from "react";
import { Form } from "react-bootstrap";

export default function PreOrderCodeTableCheckbox({
  item,
  selected,
  setSelected,
}) {
  const onChange = () => {
    if (selected.includes(item.id)) {
      setSelected(cur => cur.filter(element => element !== item.id));
      return;
    }
    setSelected(cur => [...cur, item.id]);
  };

  const getValue = () => {
    return selected.includes(item.id);
  };

  return (
    <Fragment>
      {!item.total_post && (
        <Form.Check className="text-center">
          <Form.Check.Input
            checked={getValue()}
            onChange={onChange}
            className="c-pointer m-0 border-dark-subtle"
            style={{ width: 22, height: 22 }}
          />
        </Form.Check>
      )}
    </Fragment>
  );
}
